export const TipoOtpEnum = {
	APP: 1,
	EMAIL: 2,
};
